import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import { useAppState } from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import Auth, { setToken } from "../helpers/Auth";


export default function Login() {
    const { appState, setAppState } = useAppState()

    const { register, handleSubmit } = useForm();

    const onSubmit = handleSubmit((values) => {
        localStorage.setItem('test2', 'test2');
        Auth.login(values).then((data) => {
            setToken(data.token, data.expires)

            setAppState({
                user: data.user
            })
        });
    });

    return (
        <div className="min-h-screen h-0 text-dark flex justify-between flex-col bg-primary">

            <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                    <form className="space-y-6" onSubmit={onSubmit}>
                        <div>
                            <label className="block text-sm/6 font-medium text-gray-900">Email address</label>
                            <div className="mt-2">
                                <input
                                    type="email"
                                    {...register('email')}
                                    autoComplete="email"
                                    required
                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                />
                            </div>
                        </div>

                        <div>
                            <div className="flex items-center justify-between">
                                <label className="block text-sm/6 font-medium text-gray-900">Password</label>
                            </div>
                            <div className="mt-2">
                                <input
                                    type="password"
                                    {...register('password')}
                                    autoComplete="current-password"
                                    required
                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                />
                            </div>
                        </div>

                        <div>
                            <button type="submit" className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Sign in</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
